import {
  getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions,
  getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** カスタムフィールド定義データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200;
};

/**
 * useGetCustomFieldDefinitionsフックの型定義
 */
type IUseGetCustomFieldDefinitions = (args: Args) => ReturnType;

/**
 * 利用企業編集フォーム用カスタムフィールド定義取得フック
 *
 * 対象モデルは企業（c）固定
 */
export const useGetCustomFieldDefinitions: IUseGetCustomFieldDefinitions = ({
  threeLetterCode,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey(threeLetterCode, {
      f: 'c',
    }),
    () => getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions(threeLetterCode, { f: 'c' }),
    { suspense: true }
  );

  return {
    data,
  };
};
